<template>
  <div class="main">
    <div class="link-container">
      <div>
        <SubLink link_style="main-link" path="/" text="Jiaming Qiu" />
      </div>
    </div>
    <div class="img-container"></div>
    <div class="intro">
      <p class="intro-info intro-font">
        PhD candidate<br />Dept. of Computer Science<br />Washington University
        in St. Louis
      </p>
    </div>
    <ul class="intro">
      <li class="intro-font link-font">
        <font-awesome-icon
          class="icon-style"
          :icon="['fas', 'map-marker-alt']"
        />St. Louis, MO, U.S.A.
      </li>
      <li>
        <font-awesome-icon class="icon-style" :icon="['fas', 'envelope']" />
        <Link
          class="intro-font link-font"
          path="mailto:qiujiaming@wustl.edu"
          text="Email"
        />
      </li>
      <li>
        <font-awesome-icon class="icon-style" :icon="['fab', 'github']" />
        <Link
          class="intro-font link-font"
          path="https://github.com/qiujiaming315"
          text="Github"
        />
      </li>
      <li>
        <font-awesome-icon class="icon-style" :icon="['fas', 'graduation-cap']" />
        <Link
          class="intro-font link-font"
          path="https://scholar.google.com/citations?user=eIkRVZIAAAAJ&hl=en"
          text="Google Scholar"
        />
      </li>
      <li>
        <font-awesome-icon class="icon-style" :icon="['fab', 'orcid']" />
        <Link
          class="intro-font link-font"
          path="https://orcid.org/0000-0001-9576-0499"
          text="ORCID"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SubLink from "./SubLink";
import Link from "./Link";

export default {
  name: "MainInfo",
  components: {
    SubLink,
    Link,
  },
};
</script>

<style scoped>
.main {
  position: fixed;
  left: 0;
  top: 0;
  width: 360px;
  height: 100%;
  background-color: #66ccff;
  text-align: center;
  color: #2c3e50;
}
.link-container {
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #cceeff;
  box-shadow: rgba(44, 62, 80, 0.3) 0px 2px 4px 0px;
}
.link-container > div {
  position: relative;
  height: 60px;
}
.img-container {
  margin: 30px auto 0;
  width: 270px;
  height: 300px;
  border: 4px solid #cceeff;
  background-image: url("https://qiujiaming315.github.io/data/profile.jpg");
  background-position: center;
  background-size: cover;
}
.intro {
  margin: 0 auto;
  width: 270px;
  text-align: left;
}
.intro-font {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #2c3e50;
  font-size: 15px;
}
.link-font {
  font-size: 18px;
  font-weight: 300;
}
.icon-style {
  margin-right: 0.6em;
  color: #2c3e50;
}
ul {
  list-style-type: none;
  padding: 0;
}
p.intro-info {
  line-height: 150%;
}
li:not(:last-child) {
  margin-bottom: 9px;
}
@media (max-width: 1000px) {
  div.main {
    display: none;
  }
}
</style>